interface IAgent {
  isLeadFactory: boolean;
}

export const isLeadFactory = (agent: IAgent): boolean => Boolean(agent.isLeadFactory);
